export default __webpack_public_path__ + "static/media/obj8.583635ad.jpg";